import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { CryptoService } from '../crypto.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-t-discover',
  templateUrl: './t-discover.component.html',
  styleUrls: ['../topic-style.css','./t-discover.component.css']
})
export class TDiscoverComponent extends GeneralTeacherComponent  {
  method: string;
  keyP: any;
  plainText: string;
  cipherText: string;
  modus: string = "normal";
  text: any;
  tipCount = 2;
  hints=[
    {plain:"", cipher:""},
    {plain:"", cipher:""}
  ];

  constructor(protected topicsService: TopicService, protected activatedRoute: ActivatedRoute, public cryptoService: CryptoService, protected http: HttpClient) {
    super(topicsService, activatedRoute);
    this.type="discover"
    this.loadText();
    this.title = this.get("discover");
  }

  /** loads the text to generate words from */
  loadText(): Promise<any> {
    let textFile = "./assets/text_" + this.topicService.getLanguage() + ".txt";
    let self = this;
    return new Promise((resolve, reject) => {
      this.http
        .get<string>(textFile)
        .subscribe(response => {
          self.text = response;
          resolve(true);
        })
    })
  }

   /** sets information based on configuration */
   setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.method = this.configuration.typespecifics.method;
    this.keyP = this.configuration.typespecifics.key;
    this.plainText= this.configuration.typespecifics.text;
    this.cipherText = this.cryptoService.encode(this.method, this.keyP, this.plainText);
    this.hints = [];
    for(let hint of this.configuration.typespecifics.hints){
      this.hints.push({plain: hint, cipher: this.cryptoService.encode(this.method, this.keyP, hint)});
    }
    this.tipCount = this.hints.length;
  }


  generateDefinition(): any {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id; 
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/discover.png";
    definition.level = 3;
    definition.key = "crypto%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.method = this.method;
    definition.typespecifics.key = this.keyP;
    definition.typespecifics.text = this.plainText;
    definition.typespecifics.hints = [];
    for(let hint of this.hints){
      definition.typespecifics.hints.push(hint.plain);
    }
    definition.key = definition.key.concat("%", this.method.toString(), "%", this.keyP, "%", this.plainText.slice(0,20));

   return definition;
  }

  reset() {
    super.reset();
    this.title = this.get("discover");
    this.method= undefined;
    this.keyP = undefined;
    this.plainText = "";
    this.cipherText= "";
  }

  /**
   * normalizes the text and the key and computes the cipher text
   */
  onChangeEncoding() {
    if (this.plainText) {
      this.plainText = this.cryptoService.normalizeText(this.plainText);
    }
    if (this.method && (this.keyP || this.keyP == 0 || this.method == "atbash")) {
      switch (this.method) {
        case "caesar": {
          this.keyP = this.keyP % 26;
          if (this.keyP < 0) { this.keyP += 26; }
        }
      }
      if (this.plainText) {
        this.cipherText = this.cryptoService.encode(this.method, this.keyP, this.plainText);
      }
    }
    for(let i in this.hints){
      this.changeHints(+i);
    }
  }

  generate(){
    let methodCode = Math.floor(Math.random() * 2);
    this.keyP = Math.floor(Math.random() * 26);
    this.generateText();
    switch(methodCode){
      case 0: this.method = "caesar"; break;
      case 1: this.method = "atbash"; break;
    }
    this.title = this.get("discover");
    this.tipCount = 2;
    this.generateTip(0);
    this.generateTip(1);
  }

  /**
   * generates some text
   */
  generateText(){
    let phrases = this.text.text.split(/[.!?]/).map(v => v.trim()).filter(v => v.trim().length > 0).filter(v => v.length < 150);
    let index = Math.floor(Math.random() * phrases.length);
    this.plainText = this.cryptoService.normalizeText(phrases[index]);
    this.onChangeEncoding();
  }

  /** normalize the hints and compute the cipher */
  changeHints(i:number) {
    this.hints[i].plain = this.cryptoService.normalizeText(this.hints[i].plain);
    if(this.method && (this.keyP || this.keyP == '0' || this.method == "atbash")){
      this.hints[i].cipher = this.cryptoService.encode(this.method, this.keyP, this.hints[i].plain);
    }
  }

  /** generate a text for the given tip
   * @param i - index of tip
   */
  generateTip(i: number){
    let phrases = this.text.text.split(/[.!?]/).map(v => v.trim()).filter(v => v.trim().length > 0).filter(v => v.length < 150);
    let index = Math.floor(Math.random() * phrases.length);
    this.hints[i].plain = this.cryptoService.normalizeText(phrases[index]);
    this.changeHints(i);
  }
  
  /**
   * add a new tip
   */
  incrementTip(){
    this.tipCount++;
    this.hints.push({plain:"", cipher:""});
  }

  /**
   * remove the given tip
   * @param i - tip to remove
   */
  deleteHint(i:number){
    this.tipCount--;
    this.hints.splice(i,1);
  }

  getMethodDescription(){
    switch(this.method){
      case "caesar": return this.get("useCaesar");
      case "polybius": return this.get("usePolybius");
      case "skytale": return this.get("useSkytale");
      case "monoalphabetic": return this.get("useMonoalphabetic");
      case "vignere": return this.get("useMask");
      case "vignereDigits": return this.get("useMask");
      case "vignereLetters": return this.get("useMask");
      case "pigpen": return this.get("usePigpen");
      case "atbash": return this.get("useAtbash");
      case "morse": return this.get("useMorse");
    }
  }

}
